export const PROGRAM_OPTIONS = [
  { value: 'paylink_eu', label: 'PayLink EU' },
  { value: 'fincore_us', label: 'FinCore US' },
  { value: 'payworld_pk', label: 'PayWorld PK' },
  { value: 'merchant_direct', label: 'Merchant Direct' },
]
